/**
 * The productDetail.js module in LINK_cybersource requires the detail.js module twice,
 * once relatively from its own directory, and once from the 'base' path.
 *
 * This cannot work with the dependency chain plugin, since it would just lead
 * to the top-most detail.js being executed twice.
 *
 * This is why the LINK_cybersource productDetail.js module is just skipped -
 * this has the same effect as the original code, as the two detail.js modules will be chained,
 * and the resulting top-level module will be executed
 */
import '~base/~base';
